// https://www.npmjs.com/package/sprintf-js
// https://github.com/alexei/sprintf.js/blob/master/test/test.js
// https://github.com/silentmatt/expr-eval

import { sprintf } from "sprintf-js";
import { Parser } from "expr-eval";
import dayjs from "dayjs";

function indexOfColon(str: string): number {
  if (str) {
    let skip = 0;
    for (let i = 0; i < str.length; i++) {
      if (str[i] === "(") {
        skip++;
      } else if (str[i] === ")") {
        skip--;
      } else if (skip === 0 && str[i] === ":") {
        return i;
      }
    }
  }
  return -1;
}

function evaluateSingle(str: string, args: any, argsMap: Map<string, object>): string {
  if (str) {
    let format = "";
    let index = indexOfColon(str);
    if (index >= 0) {
      format = str.substring(index + 1);
      str = str.substring(0, index);
    }
    if (str) {
      if (str.charAt(0) === "%") {
        // is expression
        str = str.substring(1);
        try {
          var parser = new Parser();
          var expr = parser.parse(str);
          str = expr.evaluate(args);
        } catch (err: any) {
          return `Evaluate expression failed: ${JSON.stringify({ message: err.message, expression: str, args })}`;
        }
      } else {
        // simple replace
        const arg = argsMap.get(str);
        if (arg instanceof Date) {
          if (format) {
            str = dayjs(arg).format(format);
            format = "";
          } else {
            str = dayjs(arg).format("YYYY-MM-DD");
          }
        } else if (arg !== undefined) {
          str = "" + arg;
        }
      }
      if (str && format) {
        try {
          str = sprintf(format, str);
        } catch (err: any) {
          return `Format failed: ${JSON.stringify({ message: err.message, value: str, format })}`;
        }
      }
    }
  }
  return str;
}

export function hasTokenMarkup(str: string): boolean {
  if (str && typeof str === "string") {
    let index1 = str.indexOf("{{");
    if (index1 >= 0) {
      let index2 = str.indexOf("}}", index1);
      if (index2 > index1) return true;
    }
  }
  return false;
}

export function evaluate(str: string, args: any): string {
  if (str && args) {
    const argsMap = new Map<string, object>(Object.entries(args));
    if (argsMap.size > 0) {
      let result = "";
      let position = 0;
      while (position < str.length) {
        let index1 = str.indexOf("{{", position);
        if (index1 >= 0) {
          let index2 = str.indexOf("}}", index1);
          if (index2 > index1) {
            const sub = str.substring(index1 + 2, index2);
            if (index1 > position) result += str.substring(position, index1);
            result += evaluateSingle(sub, args, argsMap);
            position = index2 + 2;
            continue;
          }
        }
        result += str.substring(position);
        break;
      }
      return result;
    }
  }
  return str;
}
